<template>
	<div>
		<Header />
		<div class="content">
			<div class="w-1200 clearfix">
				<div class="block-wrap">
					<div class="block-wrap-h">
						<div class="block-wrap-h-l">
							<i class="el-icon-arrow-left icon-color"></i>
							<span class="">返回首页</span>
						</div>
						<h2 class="block-wrap-h-t">实名提交</h2>
						<div>

						</div>
					</div>
					<div class="block-wrap-ipt">

						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="460px"
							class="demo-ruleForm">
							<el-form-item label="意见内容" prop="textarea">
								<el-input class="textarea" type="textarea" placeholder="请输入您想提交的建议信息，100以内..." rows="5"
									v-model="ruleForm.textarea" maxlength="100" show-word-limit>
								</el-input>
							</el-form-item>

							<el-form-item label="单位名称" prop="company">
								<el-input v-model="ruleForm.company" size="small" class="inpyabeb"
									placeholder="请输入您所在的单位名称"></el-input>
							</el-form-item>


							<el-form-item label="联系号码" prop="tel">
								<el-input v-model="ruleForm.tel" size="small" class="inpyabeb" placeholder="请输入您的联系号码">
								</el-input>
							</el-form-item>
							<el-form-item label="真实姓名" prop="name">
								<el-input v-model="ruleForm.name" size="small" class="inpyabeb" placeholder="请输入您的真实姓名">
								</el-input>
							</el-form-item>
							<el-form-item label="验证码" prop="code">
								<el-input v-model="ruleForm.code" size="small" class="ipt-code"
									placeholder="请输入右侧图片内文字">
								</el-input>
								<div style="display: flex;margin-left: 13px;">
									<SIdentify :identifyCode="identifyCode"></SIdentify>
									<img src="../assets/sj.png" @click="changeCode()"
										style="cursor: pointer;margin-left: 10px; margin-top:5px;width: 22px;height: 22px;" />
								</div>

							</el-form-item>

							<div class="block-solid"></div>
							<el-form-item>
								<el-button type="primary" icon="el-icon-check" style="background-color:#194ABE"
									@click="submitForm('ruleForm')" size="small" class="block-submit margin-top-36">
									提交申请
								</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
		<Footer />

	</div>
</template>

<script>
	import Header from "../components/Header";
	import Footer from "../components/Footer";
	import SIdentify from "../components/Modal/SIdentify.vue";
	export default {
		name: "Feedback",
		components: {
			Header,
			Footer,
			SIdentify
		},
		data() {
			return {
				ruleForm: {

					textarea: "",
					company: '',
					tel: '',
					name: '',
					code: ''
				},
				// 验证码初始值
				identifyCode: '1234',
				// 验证码的随机取值范围
				identifyCodes: '1234567890',
				rules: {
					textarea: [{
						required: true,
						message: '建议内容',
						trigger: 'blur'
					}],
					company: [{
						required: true,
						message: '请输入您所在的单位名称',
						trigger: 'blur'
					}],
					tel: [{
						required: true,
						message: '请输入单位地址',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请输入您的真实姓名',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '请输入右侧图片内验证码',
						trigger: 'blur'
					}],

				}
			};
		},
		mounted() {
			// 刷新页面就生成随机验证码
			this.identifyCode = ''
			this.makeCode(this.identifyCodes, 4)
		},
		methods: {
			// 点击验证码刷新验证码
			changeCode() {
				this.identifyCode = ''
				this.makeCode(this.identifyCodes, 4)
			},
			// 生成一个随机整数  randomNum(0, 10) 0 到 10 的随机整数， 包含 0 和 10
			randomNum(min, max) {
				max = max + 1
				return Math.floor(Math.random() * (max - min) + min)
			},
			// 随机生成验证码字符串
			makeCode(data, len) {
				for (let i = 0; i < len; i++) {
					this.identifyCode += data[this.randomNum(0, data.length - 1)]
				}
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log('通过')
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},

		},
	};
</script>

<style lang="less" scoped="scoped">
	/deep/.ipt-code .el-input__inner {
		width: 245px;
	}

	/deep/.el-form-item__content {
		display: flex;
	}

	/deep/.el-form-item__content {
		line-height: 0px;
		position: relative;
		font-size: 14px;
	}

	/deep/.el-input__inner {
		width: 382px;
		height: 36px;
		line-height: 36px;
	}

	/deep/.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
	}

	/deep/.el-input {
		position: relative;
		font-size: 14px;
		display: inline-block;
		width: auto;
	}

	.block-wrap {
		padding: 0px 30px 30px 30px;
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 30px;
		margin-bottom: 30px;


		&-h {
			height: 63px;
			border-bottom: 1px solid #D4DBDD;
			display: flex;
			justify-content: space-between;
			align-items: center;

			&-l {
				width: 109px;
				height: 36px;
				border: 1px solid #C8CDD5;
				border-radius: 6px;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #7C828A;
			}

			&-t {
				font-size: 26px;
				color: #194ABE;
				font-weight: 700;
			}
		}

		&-ipt {
			margin-top: 40px;
		}
	}

	.icon-color {
		color: #194ABE;
	}


	.inpyabeb {}

	.textarea {
		width: 560px;
		background: #FFFFFF;
		border: 1px solid #BDC3CB;
		opacity: 1;
		border-radius: 4px;
	}
</style>
